import React from 'react';
import Toggle from './Toggle.js';

const SupervisionToggle = settings => {
    return ({ value, row, loadData }) => {
        return <Toggle initialValue={value} row={row} loadData={loadData} />;
    };
};

export default SupervisionToggle;
